import { useState } from 'react';

const faqs = [
  {
    q: 'What is a Kakobuy Spreadsheet?',
    a: 'A Kakobuy Spreadsheet is a curated, regularly updated document that organizes product listings from verified sellers across multiple categories. It helps buyers quickly locate trusted sellers, compare prices, and discover trending items without manually searching through unorganized platforms.',
  },
  {
    q: 'How often is the kakobuy spreadsheet updated?',
    a: 'Our kakobuyspreadsheet is refreshed daily. Links are checked for availability, seller ratings are recalculated based on the latest community feedback, and new trending items are added every 24 hours.',
  },
  {
    q: 'Is the Kakobuy Spreadsheet free to use?',
    a: 'Yes, the kakobuy spreadsheet resource is completely free. We believe transparent, organized buying information should be accessible to everyone. Simply browse the categories and click through to explore listings.',
  },
  {
    q: 'How do I know the sellers in the spreadsheet are trustworthy?',
    a: 'Every seller listed in the best kakobuy spreadsheet undergoes our multi-step verification process: community feedback analysis, link health monitoring, and periodic manual review. Sellers with declining reputation scores are flagged or removed.',
  },
  {
    q: 'Can I use the kakobuy spreadsheet on mobile?',
    a: 'Absolutely. The kakobuyspreadsheet website is fully responsive and optimized for mobile browsing. Category pages load quickly, and the dropdown navigation works smoothly on any screen size.',
  },
  {
    q: 'What categories are available in the kakobuy spreadsheet?',
    a: 'The kakobuy spreadsheet covers 14 major categories including Shoes, Hoodies/Sweaters, T-Shirts, Jackets, Pants/Shorts, Headwear, Sets, Underwear, Jersey, Accessories, Bags, Belts, Perfumes, and Other Stuff.',
  },
  {
    q: 'How do I report a broken link or suspicious seller?',
    a: 'Visit our main platform at kakobuyspreadsheet and use the contact options. Our team reviews reports within 24 hours and updates the spreadsheet accordingly.',
  },
  {
    q: 'What makes this the best kakobuy spreadsheet resource?',
    a: 'Unlike static lists, our kakobuy spreadsheet combines real-time link monitoring, community-driven seller ratings, and editorial buying guides. This three-layer system ensures accuracy, freshness, and buyer safety that generic spreadsheets cannot match.',
  },
  {
    q: 'Do you offer buying guides for specific categories?',
    a: 'Yes. Our buying guides section covers Shoes, Bags, Accessories, and Clothing in detail. Each guide includes pricing trends, sizing tips, and seller comparison data drawn directly from the kakobuy spreadsheet.',
  },
  {
    q: 'How do I get started with the Kakobuy Spreadsheet?',
    a: 'Simply browse the category dropdown at the top of this page, select your preferred category, and you will be directed to the corresponding kakobuy spreadsheet listings on our main platform. There is no signup required.',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-12">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-semibold tracking-wide uppercase mb-3">
            Common Questions
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900">
            Frequently Asked Questions
          </h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto mt-4 leading-relaxed">
            Everything you need to know about using the <strong>kakobuy spreadsheet</strong> to find trusted sellers and make smarter buying decisions.
          </p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-100 border border-background-200/70 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === i ? null : i)}
                className="w-full flex items-center justify-between px-5 py-4 text-left cursor-pointer"
              >
                <span className="font-heading font-semibold text-sm md:text-base text-foreground-900 pr-4">
                  {faq.q}
                </span>
                <span className={`w-7 h-7 flex-shrink-0 flex items-center justify-center rounded-full transition-colors duration-300 ${
                  openIndex === i
                    ? 'bg-primary-500 text-white'
                    : 'bg-background-200 text-foreground-500'
                }`}>
                  <i className={`text-sm ${openIndex === i ? 'ri-subtract-line' : 'ri-add-line'}`}></i>
                </span>
              </button>
              {openIndex === i && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}